import { Mail, Play } from "lucide-react";
import { spectacles, videos } from "@/lib/data";

export const Spectacles = () => (
  <section id="spectacles" className="py-24 md:py-32 bg-[#0A0A0A] text-white" data-testid="spectacles-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-14 max-w-3xl">
        <span className="font-sans text-sm font-bold tracking-[0.25em] uppercase text-[#FFD1DC]">
          Sur scène
        </span>
        <h2 className="mt-3 font-display text-5xl md:text-7xl leading-none uppercase">
          Spectacles <br />
          <span className="text-[#FFF3B0]">vivants</span>
        </h2>
        <p className="mt-5 text-lg text-white/70 max-w-xl">
          Des créations qui bougent, qui dérangent, qui font rire — et qui laissent une trace.
        </p>
      </div>

      {/* Spectacles */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-16">
        {spectacles.map((s) => (
          <article
            key={s.id}
            className="bg-[#1a1a1a] border border-white/15 rounded-3xl overflow-hidden hover:border-white/40 transition-colors group"
            data-testid={`spectacle-card-${s.id}`}
          >
            <div className={`overflow-hidden ${s.id === "bienvenue" ? "aspect-square bg-black" : "aspect-[4/3]"}`}>
              <img
                src={s.image}
                alt={s.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                style={{ objectPosition: s.id === "bienvenue" ? "50% 28%" : "center" }}
              />
            </div>
            <div className="p-6">
              <p className="font-sans text-xs tracking-widest uppercase text-white/50">{s.type}</p>
              <h3 className="mt-2 font-display text-3xl md:text-4xl uppercase">{s.title}</h3>
              <p className="mt-3 text-sm text-white/70 leading-relaxed">{s.description}</p>
              {s.nextDate && (
                <p className="mt-3 text-sm font-bold text-[#FFF3B0]">{s.nextDate}</p>
              )}
              {s.credit && <p className="mt-3 text-xs text-white/40 italic">{s.credit}</p>}
              <a
                href={s.href}
                data-testid={`spectacle-cta-${s.id}`}
                className="mt-5 inline-flex items-center gap-2 text-[#FFF3B0] font-sans font-bold text-sm hover:gap-3 transition-all"
              >
                <Mail size={16} />
                Infos & programmation
              </a>
            </div>
          </article>
        ))}
      </div>

      {/* Videos */}
      <div>
        <h3 className="font-display text-3xl md:text-4xl uppercase mb-6">Vidéos</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {videos.map((v) => (
            <div
              key={v.id}
              className="aspect-video bg-[#1a1a1a] border border-white/15 rounded-2xl overflow-hidden flex items-center justify-center text-center"
              data-testid={`video-slot-${v.id}`}
            >
              {v.embed ? (
                <iframe
                  src={v.embed}
                  title={v.title}
                  className="w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              ) : (
                <div className="p-6">
                  <Play size={42} className="mx-auto text-white/50 mb-3" />
                  <p className="font-sans text-sm text-white/60">{v.title}</p>
                  <p className="font-sans text-xs text-white/30 mt-1 italic">Vidéo à intégrer prochainement</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
